import { toast } from 'sonner';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useDeleteAlbum } from '@/hooks/useAlbums';
import type { AlbumListItem } from '@/lib/api';

interface DeleteAlbumDialogProps {
  album: AlbumListItem | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: () => void;
}

export function DeleteAlbumDialog({
  album,
  open,
  onOpenChange,
  onSuccess,
}: DeleteAlbumDialogProps) {
  const deleteAlbum = useDeleteAlbum();

  const handleDelete = async () => {
    if (!album) return;

    try {
      await deleteAlbum.mutateAsync(album.id);
      toast.success('アルバムを削除しました');
      onOpenChange(false);
      onSuccess?.();
    } catch {
      toast.error('アルバムの削除に失敗しました');
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>アルバムを削除</AlertDialogTitle>
          <AlertDialogDescription>
            「{album?.name}」を削除してもよろしいですか？この操作は取り消せません。
            アルバム内の写真は削除されません。
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>キャンセル</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={deleteAlbum.isPending}
          >
            {deleteAlbum.isPending ? '削除中...' : '削除'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
